import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  sessions: [],
  selectedIndex: null, // Add your additional state here
  seletctedChildIndex: null,
};
const sessionSlice = createSlice({
  name: "Session",
  initialState,
  reducers: {
    setSessions: (state, action) => {
      state.sessions = action.payload;
    },
    setSelectedIndex: (state, action) => {
      state.selectedIndex = action.payload;
    },
    setSelectedChildIndex: (state, action) => {
      state.seletctedChildIndex = action.payload;
    },
  },
});
export const { setSessions, setSelectedIndex, setSelectedChildIndex } =
  sessionSlice.actions;
export default sessionSlice.reducer;
